import { Injectable } from '@angular/core'
import { Language } from '../types/language'
import { LANGUAGE_CODES, languageLSKey } from '../constants/language'

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  constructor() {}

  /**
   * Adds user preferred language to local storage
   * @param {Language} language user selected language
   */
  storeLanguageInLS(language: Language) {
    localStorage.setItem(languageLSKey, JSON.stringify(language))
  }

  /**
   * Retrieves user preferred language from local storage
   * @returns {Language | undefined } The language (if any)
   */
  getLanguageFromLS(): Language | undefined {
    try {
      const languageLS = localStorage.getItem(languageLSKey)
      if (languageLS) {
        const locale = JSON.parse(languageLS) as Language
        if (locale && Object.values(LANGUAGE_CODES).includes(locale.code)) {
          return locale
        }
      }
      return undefined
    } catch {
      return undefined
    }
  }

  /** Redirect only when this page was built with a locale-specific base URL. */
  getLanguageRedirectUrl(
    language: Language,
    currentUrl: string = location.href,
    baseUrl: string = document.baseURI,
  ): string | undefined {
    const locales = Object.values(LANGUAGE_CODES)
    const baseLocale = new URL(baseUrl).pathname.split('/')[1]
    if (!locales.includes(baseLocale)) return undefined

    const url = new URL(currentUrl)
    const segments = url.pathname.split('/')
    if (segments[1] === language.code) return undefined
    if (locales.includes(segments[1])) segments.splice(1, 1)
    url.pathname = `/${language.code}${segments.join('/') || '/'}`
    return url.href
  }
}
